import { CustomFieldForm } from "../../Customization/CustomFields/CustomFieldsForm";
import { CustomField } from "../CustomFields/CustomFields";
import {
  PropertyTranslator,
  IEntryRecordParametersTranslator,
  IModifiedRecordParametersTranslator,
  IEntryRecordLabels,
  IModificationRecordLabels,
  IRelatedEntityLabels,
  IUniqueEntityLabels,
  IUniqueEntityParametersTranslator,
  INamedEntityParametersTranslator,
} from "../GenericTranslator";
import {
  EntryRecordOrderBy,
  ModificationRecordOrderBy,
  EntityConstants,
  ICreatedRecordParameters,
  IEntityMinimalModel,
  IEntryRecord,
  IModificationRecord,
  IModifiedRecordParameters,
  INamedEntity,
  IRelatedEntity,
  IRelation,
  IRelationModel,
  IUniqueEntity,
  IUniqueEntityParameters,
  Nullable,
} from "../GenericTypes";
import {
  CustomTypeBase,
  CustomTypeBaseFieldLabels,
  CustomTypeBaseFilters,
  CustomTypeBaseFiltersTranslator,
  CustomTypeBaseSection,
  CustomTypeBaseSortingOptionsConsts,
} from "./CustomTypesBase";

export const customTypeConstants: EntityConstants<CustomType, CustomTypeFilters> = {
  resource: "types",
  frontendIndexRoute: "types",
  entitySingular: "custom type",
  entityPlural: "custom types",
  icon: "panel-top",
};

export const minimalCustomType = "Minimal" as const;

export interface CustomType
  extends CustomTypeBase,
    IUniqueEntity,
    IEntryRecord,
    IModificationRecord,
    IRelatedEntity<CustomTypeRelations> {
  sections: CustomTypeSection[];
  customTypeTemplate?: IEntityMinimalModel;
}

export interface CustomTypeWriteModel extends Partial<Nullable<Omit<CustomType, "sections">>> {
  sections?: Partial<Nullable<CustomTypeSectionWriteModel>>[];
}

export const CustomTypeFieldLabels: PropertyTranslator<CustomType> = {
  ...CustomTypeBaseFieldLabels,
  ...IUniqueEntityLabels,
  ...IEntryRecordLabels,
  ...IModificationRecordLabels,
  ...IRelatedEntityLabels,
  sections: "Sections",
  customTypeTemplate: "Based on template",
} as const;

export interface CustomTypeSection extends CustomTypeBaseSection, INamedEntity {
  customFields: CustomField[];
}

export interface CustomTypeSectionWriteModel extends Partial<Nullable<Omit<CustomTypeSection, "customFields">>> {
  customFields: Partial<CustomFieldForm>[];
}

export interface CustomTypeRelations extends IRelationModel {
  datasets: IRelation;
  samples: IRelation;
  inventoryItems: IRelation;
  persons: IRelation;
  projects: IRelation;
}

export interface CustomTypeFilters
  extends CustomTypeBaseFilters<CustomTypeSortingOptions>,
    IUniqueEntityParameters,
    ICreatedRecordParameters,
    IModifiedRecordParameters {
  customTypeTemplateIds?: number[] | null;
  excludeEmptyCustomTypes?: boolean | null;
}

export const CustomTypeSortingOptionsConsts = [
  ...CustomTypeBaseSortingOptionsConsts,
  ...EntryRecordOrderBy,
  ...ModificationRecordOrderBy,
] as const;
export type CustomTypeSortingOptions = (typeof CustomTypeSortingOptionsConsts)[number];

export const CustomTypeFiltersTranslator: PropertyTranslator<CustomTypeFilters> = {
  ...CustomTypeBaseFiltersTranslator,
  ...IUniqueEntityParametersTranslator,
  ...INamedEntityParametersTranslator,
  ...IEntryRecordParametersTranslator,
  ...IModifiedRecordParametersTranslator,
  customTypeTemplateIds: "Custom type template ID(s)",
  excludeEmptyCustomTypes: "Exclude empty custom types",
} as const;
